import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { addBreadcrumb } from '@/lib/sentry';

/**
 * Hook to track navigation events as Sentry breadcrumbs.
 * Add this to your root App component inside the Router.
 */
export const useSentryNavigation = () => {
  const location = useLocation();

  useEffect(() => {
    addBreadcrumb(
      `Navigated to ${location.pathname}`,
      'navigation',
      {
        pathname: location.pathname,
        search: location.search || undefined,
        hash: location.hash || undefined,
      }
    );
  }, [location.pathname, location.search, location.hash]);
};
